import {Component} from 'react';
import { connect } from 'react-redux';
import CarInput from '../shared-components/car_input';
import CarChangeModal from '../game-views/car_change_modal';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import { removeConditionsTable } from './objects/remove_Conditions_Table_function';
import { setupConditionsUpdate } from './objects/set_up_conditions_update_function';
import { resetPicturesForChanges } from './objects/reset_pictureInfo_for_changes';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import ConfigFile from '../../datasets/config_file';
import createEventTrackerUpdateObject from '../../objects/CommonUse/create_eventTracker_update_object';
import updateGamePurchaseArr from './objects/update_game_purchase_arr';

// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gamePurchases: state.gamePurchases,
    // add other Redux state slices here if needed
});

class CarChange extends Component {
  
    constructor(props) {
        super(props);
        this.gameInfo = this.props.gameInfo();
        this.state = {
            openCarChangeModal: false,
            headers: setHeadersForFetch(),
            subProcess: "carChange",
            environment: Config.dataURL.currentEnv,
            previousCarName: this.gameInfo.pictureInfo.carName,
        }
        this.conditionList = null;
        
    }    

    componentDidMount(){
        this.loadConditions();
    }
    
    loadConditions()
    {
        const funcName = "eventConditionsList";
        const urlParm = "?triggeredByList=monthly,carChange&conditionClass=car";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.conditionList = output.body;
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        }
        });
    }

    render() {
       
    return <>
            {this.state.openCarChangeModal === true ?
                <CarChangeModal show={this.state.openCarChangeModal} 
                    onClose={() => this.closeCarChangeModal()} 
                    onConfirmCarChange={() => this.onConfirmCarChange()}
                    gameInfo = {() => this.props.gameInfo()}
                    setGameInfo = {(value, propertyName) => this.props.setGameInfo(value, propertyName)}
                    processError = {(errorObj) => this.props.processError(errorObj)}
                   />
            :
                <div></div>
            }
            <CarInput onSelected={() => this.onCarSelected()} 
                currentGameDate = {this.gameInfo.gameData.currentGameDate}
                startGameDate = {this.gameInfo.gameData.startGameDate}
                currentCarID = {this.gameInfo.gameData.carInfo.carID}
                processError = {(errorObj) => this.props.processError(errorObj)}
                />
    </>
    }

    onCarSelected() {
        this.setState({openCarChangeModal: true});
    }
   
    closeCarChangeModal() {
        this.setState({openCarChangeModal: false});
    }

    onConfirmCarChange() {
        this.setState({openCarChangeModal: false});
        this.getSessionStorage();
        this.updateConditionTable();
        if (ConfigFile.general.eventTracker === true){
            this.saveEventTracker();
        }
        this.setBodyObj();
        if (+this.carType === 50){
            this.checkUpdateOfGamePurchases();
        }
        this.updateCarInfo();
        this.updatePictureInfo();
    }

    checkUpdateOfGamePurchases(){
        this.updateGamePurchases = false;
        if (this.props.gamePurchases &&
            this.props.gamePurchases.purchaseTable){
            const gamePurchaseArr = this.props.gamePurchases.purchaseTable;
            const purchaseObj = gamePurchaseArr.find(elem => elem.itemName === "bicycle");
            if (!purchaseObj){
                this.updateGamePurchases = true;
            }
        }else{
            this.updateGamePurchases = true;
        }
    }

    updatesAreComplete(){
        this.props.setGameInfo(this.gameInfo.gameData, 'gameData');
        this.props.setGameInfo(0, "carChangeNbrMonths");
        this.props.onChangeComplete();
        this.props.onNavigate("status-display");
    }
    
    getSessionStorage(){
        this.newCashAmt = sessionStorage.getItem("changeCarNewCashAmt");
        let chgCashAmt = ((this.gameInfo.gameData.currentCash - this.newCashAmt) * -1).toFixed(2);
        this.chgCashAmt = chgCashAmt.toString();
        this.newCarID = sessionStorage.getItem("carChoice");
        this.carAgeNbr = sessionStorage.getItem("changeCarAgeNbr");
        this.carYear = sessionStorage.getItem("changeCarYear");
        this.carType = sessionStorage.getItem("carSize");
        this.newExpenseTable = JSON.parse(sessionStorage.getItem("changeCarExpenseDataObjects"));
        this.newLoanTable = JSON.parse(sessionStorage.getItem("changeCarLoanDataObjects"));
        this.moodPointsIncrease = sessionStorage.getItem("carChangeMoodPoints");
    }
     
    setBodyObj(){
        this.gameInfo.gameData.currentCash = this.newCashAmt;
        this.gameInfo.gameData.loanTable = this.newLoanTable;
        this.gameInfo.gameData.expenseTable = this.newExpenseTable;
        this.gameInfo.gameData.currentMoodPoints = 
            (+this.gameInfo.gameData.currentMoodPoints + +this.moodPointsIncrease).toString();
        this.gameInfo.gameData.conditionsTable = this.conditionsTable;
        this.props.setGameInfo(this.gameInfo.gameData, "gameData");
        this.bodyObj = {
            "cash": this.newCashAmt, 
            "carInfo": this.gameInfo.gameData.carInfo, 
            "loanTable": this.newLoanTable,
            "expenseTable": this.newExpenseTable,
            "conditionsTable": this.conditionsTable,
            "currentMoodPoints": this.gameInfo.gameData.currentMoodPoints,
        };
    }
    
    updateConditionTable(){
        this.conditionsTable = removeConditionsTable(this.gameInfo.gameData.conditionsTable, "car");
        //  the following checks for a 'no-car'...
        if (+this.carType === 50){
             this.conditionsTable = removeConditionsTable(this.gameInfo.gameData.conditionsTable, "carRelated");
        }
        let conditionClasses = ["car"];
        this.gameInfo.gameData.carInfo = {carID: this.newCarID, carAge: this.carAgeNbr, carYear: this.carYear, 
            carType: this.carType, carGameDate: this.gameInfo.gameData.currentGameDate};
        let newCarConditionsTable = 
            setupConditionsUpdate(this.gameInfo.gameData, this.conditionList, conditionClasses);
        for (let i=0; i<newCarConditionsTable.length; i++){
            this.conditionsTable.push(newCarConditionsTable[i]);
        }
    
    }
         
    updateCarInfo()
    {  
        const funcName = "updateCarInfo";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
                {method:'PUT', headers: this.state.headers,
            body: JSON.stringify(this.bodyObj)})
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                            if (this.updateGamePurchases === true){
                                //  this means it is 'no car'
                                this.createGamePurchase();
                            }else{
                                this.updatesAreComplete();
                            }
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: this.bodyObj};
                            this.props.processError(errorObj);
                        }
                    });
                };
            });
    }

    updatePictureInfo(){
        let carID = sessionStorage.getItem("carChoice");
        let carSizeName = sessionStorage.getItem("carSizeName");
        let carName = carSizeName;
        if (carSizeName !== "No Car"){
            carName +=  (" - " + this.gameInfo.gameData.carInfo.carYear);
        }
        let carDirectory = sessionStorage.getItem("carDirectory");
        let carPictureImg = './assets/' + carDirectory;
        this.gameInfo.pictureInfo = resetPicturesForChanges("car", this.gameInfo.pictureInfo,
            carID, carName, carPictureImg, "");
        this.props.setGameInfo(this.gameInfo.pictureInfo, 'pictureInfo');
    }
    
    createGamePurchase(){
        const currentYYYYMM = this.gameInfo.gameData.currentGameDate;
        const bicycleCost = ConfigFile.gameStartItems.bicycleCost * -1;
        const imageDir = "item-1Thousand-noFriend";
        let purchaseTable = [];
        if (this.gameInfo.gamePurchases.purchaseTable){
            purchaseTable = this.gameInfo.gamePurchases.purchaseTable;
        }
        const gamePurchaseArr = updateGamePurchaseArr("bicycle", imageDir, 
            bicycleCost, currentYYYYMM, purchaseTable);
        const gameID = this.gameInfo.gameData._id
        this.gamePurchaseObj = {gameID: gameID, purchaseTable: gamePurchaseArr};
        const funcName = "updateGamePurchases";
        const urlParm = "?gameID=" + gameID;
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        fetch(uri,
            {
                method: 'PUT', 
                headers: this.state.headers,
                body: JSON.stringify(this.gamePurchaseObj)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (output.statusCode === 200){ 
                         this.props.setGameInfo(output.body, "gamePurchases");
                         this.updatesAreComplete();
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.gamePurchasesObj};
                        this.props.processError(errorObj);
                    }
                });
            }
        });
    }

    saveEventTracker(){
        let carSizeName = sessionStorage.getItem("carSizeName");
        let carName = carSizeName + " - " + this.gameInfo.gameData.carInfo.carYear;
        const carChangeInfo = {changeMade: "car", previous: this.state.previousCarName,
             new: carName,
             cashChg: this.chgCashAmt,
             conditionTable: this.conditionsTable,
             assetTable: this.gameInfo.gameData.assetTable, 
             expenseTable: this.newExpenseTable,
             loanTable: this.newLoanTable, 
             moodPoints: this.moodPointsIncrease};
        const dataObject = createEventTrackerUpdateObject("ChangeGameChoices", 
            "CarChange", this.gameInfo.gameData, carChangeInfo, this.gameInfo.creditCardInfo);
    
        const funcName = "saveEventTracker";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {
            method:'post',
            headers: this.state.headers,
            body: JSON.stringify(dataObject)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                        const output = JSON.parse(data);
                        const statusCode = output.statusCode;
                        if (statusCode === 200){
                           // update of event tracker was successful
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.message, errorObject: dataObject};
                            this.props.processError(errorObj);
                        }
                    });
                };
            });
    }
    
}
export default connect(mapStateToProps)(CarChange);